import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { GeneratedDocumentsViewModel } from "models/GeneratedDocumentsViewModel";
import { OutputDocumentsViewModel } from "models/OutputDocumentsViewModel";

export class OutputDocumentsApi {
  constructor(private axios: AxiosInstance) {}

  async getAll(meetingId: number) {
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`outputDocuments/${meetingId}`);
    const response = await this.axios.get<OutputDocumentsViewModel>(url);
    return response.data;
  }

  async generate(outputDocument: string, meetingId: number, agendaItemId?: number) {
    if (!outputDocument) throw new Error("outputDocument is required");
    if (!meetingId) throw new Error("meetingId is required");

    const url = getBoardApiUrl(`outputDocuments/${outputDocument}/${meetingId || ""}/${agendaItemId || ""}`);
    const response = await this.axios.post<GeneratedDocumentsViewModel>(url);
    return response.data;
  }
}
